import { render, staticRenderFns } from "./ModelBase.vue?vue&type=template&id=1fbf0daf&scoped=true"
import script from "./ModelBase.vue?vue&type=script&lang=js"
export * from "./ModelBase.vue?vue&type=script&lang=js"
import style0 from "./ModelBase.vue?vue&type=style&index=0&id=1fbf0daf&prod&lang=css"
import style1 from "./ModelBase.vue?vue&type=style&index=1&id=1fbf0daf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf0daf",
  null
  
)

export default component.exports